import { TaskDetails } from '@client/components/tasks/TaskDetails';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/workload-manager/tasks/calendar/details/$id')({
    staticData: {
        metadata: {
            title: 'Task details',
        },
        presentation: 'overlay',
    },
    params: {
        parse({ id }) {
            return { id: BigInt(id) };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return <TaskDetails id={Route.useParams().id} />;
}
